import Backbone from 'backbone';
import Constants from 'root/constants';
import Cache from 'root/cache';
import Util from 'root/module/util';

var Account = Backbone.Model.extend({
    defaults: {
        company                   : '',
        email                     : '',
        website                   : '',
        phone                     : '',
        address                   : '',
        join_time                 : 0,
        domain_key                : '',
        referral_code             : '',
        timezone                  : 'America/New_York',
        country                   : 'country',
        plan                      : 0,
        extra_user                : 0,
        user_limit                : 0,
        project_limit             : 0,
        session_limit             : 0,
        portal_limit              : 0,
        response_limit            : 0,
        user_db_limit             : 0,
        premium_user_limit        : 0,
        premium_project_limit     : 0,
        premium_response_limit    : 0,
        premium_session_limit     : 0,
        premium_segment_limit     : 0,
        premium_session_retention : 0,
        premium_monthly_price     : 0,
        premium_annual_price      : 0,
        is_trial                  : true,
        is_expired                : false,
        is_confirmed              : false,
        is_highrisk               : false,
        referral_balance          : 0,
        referral_credit_total     : 0,
        referral_credit_used      : 0,
        credit                    : 0,
        discount                  : 0,
        discount_type             : 0,
        discount_plan_type        : 0,
        trial_expiry_date         : 0,
        delete_time               : 0,
        upgrade_time              : 0,
        plan_change_time          : 0,
        billing_email             : '',
        billing_day               : 1,
        billing_interval          : Constants.MONTHLY,
        credit_card_digit         : '',
        stripe_customer_id        : '',
        appsumo                   : false,
        referred_by               : 0,
        upgrade_type              : 0,
        is_gdpr                   : false,
        use_case                  : '',
        hear_from                 : '',
        last_active_time          : 0,
        total_users               : 0,
        overdue_days              : 0,
        sso_domain                : '',
        addon                     : '',
        signup_plan               : ''
    },

    isSSO: function() {
        return this.get('sso_domain') !== '';
    },

    displayOnboarding: function() {
        return this.get('is_trial') && !this.get('company');
    },

    displayUpgrade: function() {
        return this.get('is_expired') || this.get('is_trial') || this.get('plan') === Constants.PLAN_2025_FREE;
    },

    getOnboardingProgress: function() {
        return {
            code_install    : Cache.account.get('onboarding').widget_install          ? true : false,
            invite_members  : Cache.account.get('onboarding').workspace_members_add   || Cache.workspace_member.length > 1 || Cache.user_invitation.length > 0 ? true : false,
            create_feedback : Cache.account.get('onboarding').create_project_feedback || Cache.project.where({project_type: 'feedback'}).length > 0 ? true : false,
            create_survey   : Cache.account.get('onboarding').create_project_survey   || Cache.project.where({project_type: 'survey'}).length > 0 ? true : false
        };
    },

    onboarding2025AbTest: function() {
        // a: new account onboarding
        // b: old
        return (Cache.account.id % 4 === 0 || Cache.account.id % 4 === 1) && Cache.account.get('join_time') > 1733803200 ? 'a' : 'b';
    },

    isPricing2024: function() {
        return [
            Constants.PLAN_2024_STARTER,
            Constants.PLAN_2024_SCALE,
            Constants.PLAN_2024_STARTER_A,
            Constants.PLAN_2024_SCALE_A,
            Constants.PLAN_2024_CUSTOM
        ].indexOf(this.get('plan')) !== -1;
    },

    isPricing2025: function() {
        return [
            Constants.PLAN_2025_FREE,
            Constants.PLAN_2025_TEAM,
            Constants.PLAN_2025_BUSINESS,
            Constants.PLAN_2025_BUSINESS_PLUS,
            Constants.PLAN_2025_CUSTOM
        ].indexOf(this.get('plan')) !== -1;
    },

    getBasePrice: function(plan, billing_interval) {
        if (this.get('appsumo')) {
            return 0;
        }

        switch (plan) {
            case Constants.PLAN_2022_SOLO:
                return billing_interval === Constants.MONTHLY ? 19 : 14;
            case Constants.PLAN_2022_STARTUP:
                return billing_interval === Constants.MONTHLY ? 79 : 59;
            case Constants.PLAN_2022_COMPANY:
                return billing_interval === Constants.MONTHLY ? 159 : 119;
            case Constants.PLAN_2022_PREMIUM:
                return billing_interval === Constants.MONTHLY ? 289 : 217;
            case Constants.PLAN_2024_STARTER:
                return billing_interval === Constants.MONTHLY ? 49 : 37;
            case Constants.PLAN_2024_SCALE:
                return billing_interval === Constants.MONTHLY ? 99 : 74;
            case Constants.PLAN_2024_STARTER_A:
                return billing_interval === Constants.MONTHLY ? 69 : 49;
            case Constants.PLAN_2024_SCALE_A:
                return billing_interval === Constants.MONTHLY ? 149 : 109;
            case Constants.PLAN_2024_CUSTOM:
            case Constants.PLAN_2025_CUSTOM:
                if ((this.get('premium_monthly_price') && billing_interval === Constants.MONTHLY) ||
                    (this.get('premium_monthly_price') && !this.get('premium_annual_price'))
                    ) {
                    return this.get('premium_monthly_price');
                } else {
                    return this.get('premium_annual_price') / 12;
                }
            case Constants.PLAN_2025_FREE:
            case Constants.PLAN_2025_TEAM:
            case Constants.PLAN_2025_BUSINESS:
            case Constants.PLAN_2025_BUSINESS_PLUS:
                return 0;
        }

        return 0;
    },

    getExtraUserPrice: function(plan, extra_user, billing_interval) {
        if (this.get('appsumo')) {
            return 0;
        }

        var user_cost = 0;

        switch (plan) {
            case Constants.PLAN_2022_SOLO:
                user_cost = billing_interval === Constants.MONTHLY ? 6 : 4.5;
                break;
            case Constants.PLAN_2022_STARTUP:
                user_cost = billing_interval === Constants.MONTHLY ? 6 : 4.5;
                break;
            case Constants.PLAN_2022_COMPANY:
                user_cost = billing_interval === Constants.MONTHLY ? 6 : 4.5;
                break;
            case Constants.PLAN_2022_PREMIUM:
                user_cost = billing_interval === Constants.MONTHLY ? 6 : 4.5;
                break;
            case Constants.PLAN_2024_STARTER_A:
            case Constants.PLAN_2024_SCALE_A:
                user_cost = billing_interval === Constants.MONTHLY ? 6 : 4.5;
                break;
            case Constants.PLAN_2025_TEAM:
                user_cost = billing_interval === Constants.MONTHLY ? 9 : 7;
                break;
            case Constants.PLAN_2025_BUSINESS:
                user_cost = billing_interval === Constants.MONTHLY ? 19 : 15;
                break;
            case Constants.PLAN_2025_BUSINESS_PLUS:
                user_cost = billing_interval === Constants.MONTHLY ? 29 : 23;
                break;
        }

        return user_cost * extra_user;
    },

    getSessionPrice: function(plan, session_limit, billing_interval) {
        switch (plan) {
            case Constants.PLAN_2024_STARTER:
                switch (session_limit) {
                    case 3000:
                        return 0;
                    case 5000:
                        return billing_interval === Constants.MONTHLY ? 30 : 22.5;
                }
                break;
            case Constants.PLAN_2024_SCALE:
                switch (session_limit) {
                    case 1000: // aposumo is on 1000 session limit
                        return 0;
                    case 5000:
                        if (this.get('appsumo')) {
                            return billing_interval === Constants.MONTHLY ? 40 : 30;
                        } else {
                            return 0;
                        }
                    case 10000:
                        return billing_interval === Constants.MONTHLY ? 50 : 37.5;
                    case 20000:
                        return billing_interval === Constants.MONTHLY ? 135 : 101.5;
                    case 30000:
                        return billing_interval === Constants.MONTHLY ? 200 : 150;
                    case 40000:
                        return billing_interval === Constants.MONTHLY ? 245 : 184;
                    case 50000:
                        return billing_interval === Constants.MONTHLY ? 270 : 202.5;
                    case 75000:
                        return billing_interval === Constants.MONTHLY ? 350 : 262.5;
                    case 100000:
                        return billing_interval === Constants.MONTHLY ? 380 : 285;
                }

                break;
            case Constants.PLAN_2024_STARTER_A:
            case Constants.PLAN_2024_SCALE_A:
                switch (session_limit) {
                    case 2000:
                        return 0;
                    case 5000:
                        return billing_interval === Constants.MONTHLY ? 19 : 14;
                    case 10000:
                        return billing_interval === Constants.MONTHLY ? 35 : 26;
                    case 20000:
                        return billing_interval === Constants.MONTHLY ? 69 : 52;
                    case 30000:
                        return billing_interval === Constants.MONTHLY ? 99 : 74;
                    case 40000:
                        return billing_interval === Constants.MONTHLY ? 129 : 97;
                    case 50000:
                        return billing_interval === Constants.MONTHLY ? 159 : 119;
                    case 75000:
                        return billing_interval === Constants.MONTHLY ? 229 : 172;
                    case 100000:
                        return billing_interval === Constants.MONTHLY ? 299 : 224;
                }
                break;
            case Constants.PLAN_2024_CUSTOM:
            case Constants.PLAN_2025_CUSTOM:
                return 0;
            case Constants.PLAN_2025_BUSINESS_PLUS:
                switch (session_limit) {
                    case 5000:
                        return billing_interval === Constants.MONTHLY ? 19 : 15;
                    case 10000:
                        return billing_interval === Constants.MONTHLY ? 35 : 28;
                    case 20000:
                        return billing_interval === Constants.MONTHLY ? 69 : 55;
                    case 30000:
                        return billing_interval === Constants.MONTHLY ? 99 : 79;
                    case 40000:
                        return billing_interval === Constants.MONTHLY ? 129 : 103;
                    case 50000:
                        return billing_interval === Constants.MONTHLY ? 159 : 127;
                    case 75000:
                        return billing_interval === Constants.MONTHLY ? 229 : 183;
                    case 100000:
                        return billing_interval === Constants.MONTHLY ? 299 : 239;
                }
                break;
        }

        // something went wrong
        return 0;
    },

    getAddonPrice: function(plan, billing_interval, addon) {
        switch (addon) {
            case 'portal':
                switch (plan) {
                    case Constants.PLAN_2025_TEAM:
                    case Constants.PLAN_2025_BUSINESS:
                    case Constants.PLAN_2025_BUSINESS_PLUS:
                        return billing_interval === Constants.MONTHLY ? 39 : 31;
                }

                break;
        }

        return 0;
    },

    getPrice: function(plan, billing_interval, project_num, extra_user, session_limit, response_limit, addons = []) {
        if (typeof extra_user === 'undefined') {
            extra_user = 0;
        }

        if (typeof session_limit === 'undefined') {
            session_limit = 0;
        }

        var plan_cost     = 0;
        var user_cost     = 0;
        var session_cost  = 0;
        var addon_cost    = 0;

        switch (plan) {
            case Constants.PLAN_2022_SOLO:
            case Constants.PLAN_2022_STARTUP:
            case Constants.PLAN_2022_COMPANY:
            case Constants.PLAN_2022_PREMIUM:
                plan_cost    = this.getBasePrice(plan, billing_interval);
                user_cost    = this.getExtraUserPrice(plan, extra_user, billing_interval);

                return plan_cost + user_cost;
            case Constants.PLAN_2024_STARTER:
            case Constants.PLAN_2024_SCALE:
                plan_cost     = this.getBasePrice(plan, billing_interval);
                session_cost  = this.getSessionPrice(plan, session_limit, billing_interval);

                return plan_cost + session_cost;
            case Constants.PLAN_2024_STARTER_A:
            case Constants.PLAN_2024_SCALE_A:
                plan_cost     = this.getBasePrice(plan, billing_interval);
                session_cost  = this.getSessionPrice(plan, session_limit, billing_interval);
                user_cost     = this.getExtraUserPrice(plan, extra_user, billing_interval);

                return plan_cost + session_cost + user_cost;
            case Constants.PLAN_2024_CUSTOM:
                plan_cost     = this.getBasePrice(plan, billing_interval);

                return plan_cost;
            case Constants.PLAN_2025_FREE:
                return 0;
            case Constants.PLAN_2025_TEAM:
                plan_cost     = this.getBasePrice(plan, billing_interval);
                user_cost     = this.getExtraUserPrice(plan, extra_user, billing_interval);
                addon_cost    = addons && addons.indexOf('portal') !== -1 ? this.getAddonPrice(plan, billing_interval, 'portal') : 0;

                return plan_cost + user_cost + addon_cost;
            case Constants.PLAN_2025_BUSINESS:
                plan_cost     = this.getBasePrice(plan, billing_interval);
                user_cost     = this.getExtraUserPrice(plan, extra_user, billing_interval);
                addon_cost    = addons && addons.indexOf('portal') !== -1 ? this.getAddonPrice(plan, billing_interval, 'portal') : 0;

                return plan_cost + user_cost + addon_cost;
            case Constants.PLAN_2025_BUSINESS_PLUS:
                plan_cost     = this.getBasePrice(plan, billing_interval);
                user_cost     = this.getExtraUserPrice(plan, extra_user, billing_interval);
                session_cost  = this.getSessionPrice(plan, session_limit, billing_interval);
                addon_cost    = addons && addons.indexOf('portal') !== -1 ? this.getAddonPrice(plan, billing_interval, 'portal') : 0;

                return plan_cost + user_cost + addon_cost + session_cost;
            case Constants.PLAN_2025_CUSTOM:
                plan_cost     = this.getBasePrice(plan, billing_interval);

                return plan_cost;
        }

        return false;
    },

    getPlanName: function(plan) {
        var plan_name = '';

        plan = plan || this.get('plan');

        switch (plan) {
            case Constants.PLAN_2022_SOLO:
                plan_name = 'Solo';
                break;
            case Constants.PLAN_2022_STARTUP:
                plan_name = 'Startup';
                break;
            case Constants.PLAN_2022_COMPANY:
                plan_name = 'Company';
                break;
            case Constants.PLAN_2022_PREMIUM:
                plan_name = 'Premium';
                break;
            case Constants.PLAN_2024_STARTER:
            case Constants.PLAN_2024_STARTER_A:
                plan_name = 'Starter';
                break;
            case Constants.PLAN_2024_SCALE:
            case Constants.PLAN_2024_SCALE_A:
                plan_name = 'Scale';
                break;
            case Constants.PLAN_2024_CUSTOM:
                plan_name = 'Premium';
                break;
            case Constants.PLAN_2025_FREE:
                plan_name = 'Free';
                break;
            case Constants.PLAN_2025_TEAM:
                plan_name = 'Team';
                break;
            case Constants.PLAN_2025_BUSINESS:
                plan_name = 'Business';
                break;
            case Constants.PLAN_2025_BUSINESS_PLUS:
                plan_name = 'Business Plus';
                break;
            case Constants.PLAN_2025_CUSTOM:
                plan_name = 'Custom';
                break;
        }

        return plan_name;
    },

    getUsage: function() {
        var usage = this.get('billing_usage');

        return {
            feedback          : parseInt(usage.feedback, 10),
            survey_response   : parseInt(usage.survey_response, 10),
            session_recording : parseInt(usage.session_recording, 10),
        };
    },

    isResponseLimitReached: function() {
        var usage = this.getUsage();
        return usage.feedback + usage.survey_response >= this.getResponseLimit();
    },

    // Can't create (own) more than 5 workspaces
    getWorkspaceLimit: function() {
        return 10;
    },

    getUserDbLimit: function() {
        if (this.get('user_db_limit') > 0) {
            return this.get('user_db_limit');
        }

        if (this.get('is_trial')) {
            return 25000;
        }

        switch (this.get('plan')) {
            case Constants.PLAN_2024_SCALE:
            case Constants.PLAN_2024_SCALE_A:
                return 50000;
            default:
                return 25000;
        }
    },

    // Team: max 5 users
    getUserMax: function(plan) {
        if (plan === undefined) {
            plan = this.get('plan');
        }

        switch (plan) {
            case Constants.PLAN_2025_TEAM:
                return 5;
            default:
                return 150; // unlimited
        }
    },

    // how many users can be added to the account
    getUserLimit: function(plan, include_extra_user) {
        var num = 0;

        if (this.get('appsumo') && this.get('user_limit') > 0) {
            return this.get('user_limit');
        }

        if (typeof plan === 'undefined') {
            plan = this.get('plan');
        }

        if (typeof include_extra_user === 'undefined') {
            include_extra_user = true;
        }

        switch (plan) {
            case Constants.PLAN_2022_SOLO:
                num = 2;
                break;
            case Constants.PLAN_2022_STARTUP:
                num = 10;
                break;
            case Constants.PLAN_2022_COMPANY:
                num = 15;
                break;
            case Constants.PLAN_2022_PREMIUM:
                num = 25;
                break;
            case Constants.PLAN_2024_STARTER:
            case Constants.PLAN_2024_SCALE:
                num = 150; // unlimited
                break;
            case Constants.PLAN_2024_STARTER_A:
                num = 5;
                break;
            case Constants.PLAN_2024_SCALE_A:
                num = 15;
                break;
            case Constants.PLAN_2024_CUSTOM:
                num = this.get('premium_user_limit') || 150;
                break;
            case Constants.PLAN_2025_FREE:
                num = 150; // unlimited
                break;
            case Constants.PLAN_2025_TEAM:
            case Constants.PLAN_2025_BUSINESS:
            case Constants.PLAN_2025_BUSINESS_PLUS:
                num = 0; // no free included users
                break;
            case Constants.PLAN_2025_CUSTOM:
                num = this.get('premium_user_limit') || 0;
                break;
        }

        if (include_extra_user) {
            if (plan !== Constants.PLAN_2024_CUSTOM && plan !== Constants.PLAN_2025_CUSTOM) {
                num += this.get('extra_user');
            }
        }

        return num;
    },

    hasProjectLimit: function() {
        if (this.get('plan') === Constants.PLAN_2022_SOLO) {
            return true;
        }

        return false;
    },

    hasUserLimit: function(plan) {
        if (typeof plan === 'undefined') {
            plan = this.get('plan');
        }

        switch (plan) {
            case Constants.PLAN_2024_STARTER:
            case Constants.PLAN_2024_SCALE:
            case Constants.PLAN_2025_FREE:
                return false;
        }

        return true;
    },

    hasResponseLimit: function(plan) {
        if (typeof plan === 'undefined') {
            plan = this.get('plan');
        }

        if (this.get('is_trial')) {
            return true;
        }

        return false;
    },

    getProjectLimit: function(plan) {
        var num = 0;

        plan = plan || this.get('plan');

        if (this.get('project_limit') > 0) {
            return this.get('project_limit');
        }

        switch (plan) {
            case Constants.PLAN_2022_SOLO:
                num = 1;
                break;
            case Constants.PLAN_2022_STARTUP:
                num = 300; // unlimited
                break;
            case Constants.PLAN_2022_COMPANY:
                num = 300; // unlimited
                break;
            case Constants.PLAN_2022_PREMIUM:
                num = 300; // unlimited
                break;
            case Constants.PLAN_2024_STARTER:
            case Constants.PLAN_2024_SCALE:
            case Constants.PLAN_2024_STARTER_A:
            case Constants.PLAN_2024_SCALE_A:
            case Constants.PLAN_2024_CUSTOM:
                num = 300; // unlimited
                break;
            case Constants.PLAN_2025_FREE:
            case Constants.PLAN_2025_TEAM:
                num = 2;
                break;
            case Constants.PLAN_2025_BUSINESS:
                num = 25;
                break;
            case Constants.PLAN_2025_BUSINESS_PLUS:
            case Constants.PLAN_2025_CUSTOM:
                num = 300; // unlimited
                break
        }

        return num;
    },

    getUserSegmentLimit: function(plan) {
        return 50; // unlimited

        plan = plan || this.get('plan');

        switch (plan) {
            case Constants.PLAN_2024_STARTER:
            case Constants.PLAN_2024_STARTER_A:
                return 5;
            case Constants.PLAN_2024_SCALE:
            case Constants.PLAN_2024_SCALE_A:
                return this.get('appsumo') ? 20 : 15;
            case Constants.PLAN_2024_CUSTOM:
                return this.get('premium_segment_limit');
            case Constants.PLAN_2022_SOLO:
            case Constants.PLAN_2022_STARTUP:
                return 5;
            case Constants.PLAN_2022_COMPANY:
            case Constants.PLAN_2022_PREMIUM:
                return 15;
            default:
                return 1;
        }
    },

    getResponseLimit: function() {
        if (this.get('is_trial')) {
            return 100;
        }

        return 1000000; // unlimited
    },

    getSessionLimit: function() {
        if (!this.hasFeature('full_session_recording')) {
            return 0;
        } else if (this.isPricing2024()) {
            return this.get('session_limit');
        } else if (this.isPricing2025()) {
            return this.get('session_limit');
        } else{
            // pricing 2022
            if (this.get('plan') === Constants.PLAN_2022_PREMIUM) {
                return 50000;
            } else if (this.get('plan') === Constants.PLAN_2022_STARTUP) {
                return 2000;
            } else {
                return 20000;
            }
        }
    },

    getPortalLimit: function() {
        return 200;// unlimited for everyone
    },

    getResponseLimitOptions: function(plan) {
        var options = {
            [Constants.PLAN_2024_STARTER]   : [100, 250],
            [Constants.PLAN_2024_SCALE]     : [500, 1000, 2000, 3000, 4000, 5000],
            [Constants.PLAN_2024_STARTER_A] : [250],
            [Constants.PLAN_2024_SCALE_A]   : [500, 750, 1000, 1500, 2500, 5000],
            [Constants.PLAN_2024_CUSTOM]    : [500, 750, 1000, 1500, 2500, 5000]
        };

        return options[plan] || [];
    },

    getSessionLimitOptions: function(plan) {
        var options = {
            [Constants.PLAN_2024_STARTER]       : [3000, 5000],
            [Constants.PLAN_2024_SCALE]         : [5000, 10000, 20000, 30000, 40000, 50000, 75000, 100000],
            [Constants.PLAN_2024_STARTER_A]     : [2000, 5000, 10000, 20000, 30000, 40000, 50000, 75000, 100000],
            [Constants.PLAN_2024_SCALE_A]       : [2000, 5000, 10000, 20000, 30000, 40000, 50000, 75000, 100000],
            [Constants.PLAN_2024_CUSTOM]        : [2000, 5000, 10000, 20000, 30000, 40000, 50000, 75000, 100000],
            [Constants.PLAN_2025_BUSINESS_PLUS] : [0, 5000, 10000, 20000, 30000, 40000, 50000, 75000, 100000]

            // TODO: 2025
        };

        if (this.get('appsumo')) {
            options[Constants.PLAN_2024_SCALE].unshift(1000);
        }

        return options[plan] || [];
    },

    getBillingCycle: function() {
        var name = '';

        if (!this.get('is_trial') && !this.isFreePlan()) {
            switch (this.get('billing_interval')) {
                case Constants.MONTHLY:
                    name = 'Monthly';
                    break;
                case Constants.ANNUALLY:
                    name = 'Annual';
                    break;
            }
        }

        return name;
    },

    isFreePlan: function() {
        return [Constants.PLAN_2025_FREE].indexOf(this.get('plan')) !== -1;
    },

    getUsageResetDate: function() {
        if (this.get('billing_day')) {
            var next_billing_day = '';
            var today_date = (new Date()).getDate();

            if (Cache.account.get('billing_day') === today_date) {
                next_billing_day = 'today'; // it's today. so has it been reset?
            } else if (Cache.account.get('billing_day') > today_date) {
                next_billing_day = Util.now().set('date', Cache.account.get('billing_day')).format('MMM Do, YYYY');
            } else  {
                next_billing_day = Util.now().set('date', Cache.account.get('billing_day')).add(1, 'months').format('MMM Do, YYYY');
            }

            return next_billing_day;
        } else {
            return '';
        }
    },

    hasLegacyProjectCode: function() {
        // 1713967200: 2024-04-25 00:00:00
        var account_ids = [49111, 46487, 36104];

        return this.get('join_time') <= 1713967200 || account_ids.indexOf(this.id) !== -1;
    },

    hasAddon: function(addon) {
        if (this.get('is_trial')) {
            return true;
        }

        if (this.get('plan') === Constants.PLAN_2025_CUSTOM) {
            return true;
        }

        return this.get('addon') && this.get('addon').split(',').indexOf(addon) !== -1 ? true : false;
    },

    hasFeature: function(feature_name, plan) {
        if (typeof plan === 'undefined') {
            plan = this.get('plan');
        }

        if (this.get('appsumo')) {
            if (['webhook', 'powered_by'].indexOf(feature_name) !== -1) {
                return true;
            }
        }

        if (!this.isPricing2024() && !this.isPricing2025()) {
            if (this.id <= 10111 && (feature_name === 'webhook' || feature_name === 'javascript_api')) {
                return [Constants.PLAN_2022_STARTUP, Constants.PLAN_2022_COMPANY, Constants.PLAN_2022_PREMIUM].indexOf(plan) !== -1;
            }
        }

        // legacy "designs" feature
        if (feature_name === 'image_feedback') {
            // 1709301600: 2024-03-02 00:00:00
            return this.get('join_time') <= 1709301600 && plan !== Constants.PLAN_2022_SOLO;
        }

        // @HACK: temporary fix for the troublesome accounts sending too many users to us
        if (feature_name === 'user_segment') {
            if ([40763, 10703, 41501, 995].indexOf(this.id) !== -1) {
                return false;
            }
        }



        // appsumo don't get these features
        if (['ai', 'email_forwarding'].indexOf(feature_name) !== -1 && this.get('appsumo')) {
            return false;
        }

        if (this.isPricing2024()) {
            switch (feature_name) {
                case 'inbox':
                case 'team_comments':
                case 'user_identification':
                case 'user_segment':
                case 'segment_targeting':
                case 'full_session_recording':
                case 'privacy_masking':
                case 'javascript_api':
                case 'survey':
                case 'survey_trigger':
                case 'reply_templates':
                case 'notifications':
                case 'widget_custom_field':
                case 'zapier':
                case 'zendesk':
                case 'user_restriction':
                case 'integrations':
                case 'intercom':
                case 'extension_key':
                case 'client_role':
                case 'portal':
                case 'export_feedback':
                case 'session_recording':
                case 'survey_schedule':
                case 'hcaptcha':
                case 'rest_api':
                case 'automation':
                case 'merge_feedback':
                    return [Constants.PLAN_2024_STARTER, Constants.PLAN_2024_SCALE, Constants.PLAN_2024_STARTER_A, Constants.PLAN_2024_SCALE_A, Constants.PLAN_2024_CUSTOM].indexOf(plan) !== -1;
                case 'widget_branding':
                case 'white_label':
                case 'console_log':
                case 'browser_events': // legacy
                case 'custom_data':
                case 'private_portal':
                case 'webhook':
                case 'powered_by':
                case 'survey_trigger_advanced':
                case 'survey_answer_order':
                case 'ai':
                case 'email_forwarding':
                    return [Constants.PLAN_2024_SCALE, Constants.PLAN_2024_SCALE_A, Constants.PLAN_2024_CUSTOM].indexOf(plan) !== -1;
            }
        } else if (this.isPricing2025()) {
            switch (feature_name) {
                case 'portal':
                    return this.hasAddon('portal');
                case 'inbox':
                case 'team_comments':
                case 'javascript_api':
                case 'client_role':
                case 'private_portal':
                case 'notifications':
                case 'widget_custom_field':
                case 'user_restriction':
                case 'extension_key':
                    return [Constants.PLAN_2025_FREE, Constants.PLAN_2025_TEAM, Constants.PLAN_2025_BUSINESS, Constants.PLAN_2025_BUSINESS_PLUS, Constants.PLAN_2025_CUSTOM].indexOf(plan) !== -1;
                case 'integrations':
                case 'zapier':
                    return [Constants.PLAN_2025_TEAM, Constants.PLAN_2025_BUSINESS, Constants.PLAN_2025_BUSINESS_PLUS, Constants.PLAN_2025_CUSTOM].indexOf(plan) !== -1;
                case 'survey':
                case 'survey_trigger':
                case 'survey_schedule':
                case 'survey_trigger_advanced':
                case 'survey_answer_order':
                case 'user_segment':
                case 'session_recording':
                case 'export_feedback':
                case 'merge_feedback':
                case 'white_label':
                case 'widget_branding':
                case 'console_log':
                case 'custom_data':
                case 'ai':
                case 'reply_templates':
                case 'segment_targeting':
                case 'automation':
                    return [Constants.PLAN_2025_BUSINESS, Constants.PLAN_2025_BUSINESS_PLUS, Constants.PLAN_2025_CUSTOM].indexOf(plan) !== -1;
                case 'webhook':
                case 'zendesk':
                case 'intercom':
                case 'powered_by':
                case 'hcaptcha':
                case 'full_session_recording':
                case 'privacy_masking':
                case 'rest_api':
                case 'email_forwarding':
                    return [Constants.PLAN_2025_BUSINESS_PLUS, Constants.PLAN_2025_CUSTOM].indexOf(plan) !== -1;
            }
        } else {
            switch (feature_name) {
                case 'inbox':
                case 'notifications':
                case 'user_segment':
                case 'segment_targeting':
                case 'reply_templates':
                case 'automation':
                case 'merge_feedback':
                    return [Constants.PLAN_2022_SOLO, Constants.PLAN_2022_STARTUP, Constants.PLAN_2022_COMPANY, Constants.PLAN_2022_PREMIUM].indexOf(plan) !== -1;
                case 'team_comments':
                case 'widget_custom_field':
                case 'zapier':
                case 'zendesk':
                case 'user_restriction':
                case 'integrations':
                case 'intercom':
                case 'extension_key':
                case 'image_feedback':
                case 'client_role':
                case 'portal':
                case 'hcaptcha':
                case 'survey':
                case 'survey_trigger':
                case 'session_recording':
                case 'full_session_recording':
                case 'privacy_masking':
                    return [Constants.PLAN_2022_STARTUP, Constants.PLAN_2022_COMPANY, Constants.PLAN_2022_PREMIUM].indexOf(plan) !== -1;
                case 'export_feedback':
                case 'widget_branding':
                case 'white_label':
                case 'console_log':
                case 'browser_events': // legacy
                case 'javascript_api':
                case 'custom_data':
                case 'private_portal':
                case 'survey_trigger_advanced':
                case 'survey_answer_order':
                case 'ai':
                case 'email_forwarding':
                    return [Constants.PLAN_2022_COMPANY, Constants.PLAN_2022_PREMIUM].indexOf(plan) !== -1;
                case 'webhook':
                case 'rest_api':
                case 'powered_by':
                    if (this.id <= 33573) {
                        return [Constants.PLAN_2022_COMPANY, Constants.PLAN_2022_PREMIUM].indexOf(plan) !== -1;
                    } else {
                        return [Constants.PLAN_2022_PREMIUM].indexOf(plan) !== -1;
                    }
            }
        }

        return false;
    }
});

export default Account;